export default "__VITE_ASSET__C$qDgnPC__"